import { useEffect, useMemo, useRef, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SUmmerSale from "../../assets/png/summer_sale.png";
import {
  getBestSellerProduct,
  getHomeProducts,
  getHotDealsProduct,
  getTopRatedProduct,
} from "../../redux/slices/Products/productSlice";
import { dispatch } from "../../redux/store";
import { Product } from "../common";
import SpecialProductCard from "../common/SpecialProductCard";
import Loader from "../common/Loader";

const ProductsList = ({
  title,
  showViewAll = false,
  rows = 1,
  dark = false,
}: {
  title: string;
  showViewAll?: boolean;
  rows?: number;
  dark?: boolean;
}) => {
  const navigate = useNavigate();
  const { homeProducts, paginationOption, isLoading } = useSelector(
    (state: any) => state.product
  );
  const { bestSellingProducts } = useSelector((state: any) => state.product);
  const { topRatedProducts } = useSelector((state: any) => state.product);
  const { hotDealsProducts } = useSelector((state: any) => state.product);
  const [hover, setHover] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const { favorites } = useSelector((state: any) => state.favorite);
  const { auth } = useSelector((state: any) => state.auth);

  const { selectedBusinessLocation } = useSelector(
    (state: any) => state.businessLocation
  );
  useMemo(() => {
    // console.log("🚀 ~ useMemo ~ paginationOption:", paginationOption);
    dispatch(getHomeProducts(paginationOption, selectedBusinessLocation?.id));
    dispatch(getBestSellerProduct(1, 10));
    dispatch(getTopRatedProduct(0, 10));
    dispatch(getHotDealsProduct(0, 10));
  }, [selectedBusinessLocation, auth]);

  useEffect(() => {
    buttonRef.current?.addEventListener("mouseenter", () => setHover(true));
    buttonRef.current?.addEventListener("mouseleave", () => setHover(false));
  });

  if (isLoading)
    return (
      <div className="w-full flex items-center justify-center">
        <Loader />
      </div>
    );

  return (
    <div className="p-4 lg:mt-[67px] flex flex-col gap-8 mt-12">
      <div className="flex items-center w-full justify-center">
        <div className="flx flex-col items-center text-center">
          <p className="text-black font-Poppins font-[600] text-[40px]">
            {title}
          </p>
          <div className="flex gap-1 justify-center">
            <div className="h-1 w-3 bg-[#05A30D] opacity-30"></div>
            <div className="h-1 w-8 bg-[#05A30D]"></div>
            <div className="h-1 w-3 bg-[#05A30D] opacity-30"></div>
          </div>
        </div>
      </div>

      {homeProducts?.length > 0 ? (
        <div className="grid md:hidden lg:hidden grid-cols-2 gap-2 py-2 px-2 overflow-x-scroll w-full scrollbar-hide">
          {Array(rows)
            .fill(homeProducts)
            .flat()
            .slice(0, 4)
            .map((item, index) => (
              <Product
                home
                id={item.id}
                key={index}
                dark={dark}
                name={item.name}
                description={item.description}
                price={item?.sellingPriceWithTax}
                rating={item.avgRating}
                image={item?.images}
                variables={item.productVariableResponses}
                favourite={favorites?.some(
                  (favorite: any) =>
                    favorite.productResponses?.length > 0 &&
                    favorite.productResponses[0]?.id === item.id
                )}
                inStock={item.inStock ?? false}
              />
            ))}
        </div>
      ) : (
        <div className="md:hidden lg:hidden flex w-full justify-center text-center font-[600] opacity-40 text-[#05A30D]">
          No Products Available in this branch yet!
        </div>
      )}
      {homeProducts?.length > 0 ? (
        <div className="hidden md:grid md:grid-cols-4 lg:hidden md:gap-[12px] lg:gap-[12px] lg:mt-[16px] py-2 px-2 overflow-x-scroll w-full scrollbar-hide">
          {Array(rows)
            .fill(homeProducts)
            .flat()
            .slice(0, 4)
            .map((item, index) => (
              <Product
                home
                id={item.id}
                key={index}
                dark={dark}
                name={item.name}
                description={item.description}
                price={item?.sellingPriceWithTax}
                // oldPrice={item.productVariableResponses[0].sellingPrice}
                rating={item.avgProductRating}
                image={item?.images}
                variables={item.productVariableResponses}
                favourite={favorites?.some(
                  (favorite: any) =>
                    favorite.productResponses?.length > 0 &&
                    favorite.productResponses[0]?.id === item.id
                )}
                inStock={item.inStock ?? false}
              />
            ))}
        </div>
      ) : (
        <div className="hidden md:flex lg:hidden w-full justify-center text-center font-[600] opacity-40 text-[#05A30D] text-lg">
          No Products Available in this branch yet!
        </div>
      )}
      {homeProducts?.length > 0 ? (
        <div className="hidden lg:grid lg:grid-cols-5 md:gap-[12px] lg:gap-[12px] lg:mt-[16px] py-2 px-2 overflow-x-scroll w-full scrollbar-hide">
          {Array(rows)
            .fill(homeProducts)
            .flat()
            .slice(0, 5)
            .map((item, index) => (
              <Product
                home
                id={item.id}
                key={index}
                dark={dark}
                name={item.name}
                description={item.description}
                price={item?.sellingPriceWithTax}
                rating={item.avgProductRating}
                image={item?.images}
                variables={item.productVariableResponses}
                favourite={favorites?.some(
                  (favorite: any) =>
                    favorite.productResponses?.length > 0 &&
                    favorite.productResponses[0]?.id === item.id
                )}
                inStock={item.inStock ?? false}
              />
            ))}
        </div>
      ) : (
        <div className="hidden lg:flex w-full justify-center text-center font-[600] opacity-40 text-[#05A30D] text-lg">
          No Products Available in this branch yet!
        </div>
      )}
      {homeProducts?.length > 0 && (
        <div className="flex flex-col justify-end gap-5 lg:flex-row w-full py-2">
          <div className="flex flex-col md:grid md:grid-cols-3 gap-5 lg:gap-6 w-full">
            <div className="flex flex-col gap-3 w-full">
              <div className="font-semibold text-lg">Hot Deals</div>
              <div className="w-full flex flex-col gap-3">
                {hotDealsProducts?.length > 0 ? (
                  hotDealsProducts.slice(0, 3).map((item: any) => (
                    <SpecialProductCard
                      key={item.id}
                      product={{
                        id: item.productId,
                        name: item.productName,
                        sellingPriceWithTax: item.sellingPrice,
                        avgProductRating: item.rating,
                        images: item.productImages,
                      }}
                    />
                  ))
                ) : (
                  <div className="flex w-full justify-center text-center font-[600] opacity-40 text-[#05A30D]">
                    No Hot Deals Products Available
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col gap-3 w-full">
              <div className="font-semibold text-lg">Best Sellers</div>
              <div className="w-full flex flex-col gap-3">
                {bestSellingProducts?.length > 0 ? (
                  bestSellingProducts.slice(0, 3).map((item: any) => (
                    <SpecialProductCard
                      key={item.id}
                      product={{
                        id: item.productId,
                        name: item.productName,
                        sellingPriceWithTax: item.sellingPrice,
                        avgProductRating: item.rating,
                        images: item.productImages,
                      }}
                    />
                  ))
                ) : (
                  <div className="flex w-full justify-center text-center font-[600] opacity-40 text-[#05A30D]">
                    No Top Rated Products Available
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col gap-3 w-full">
              <div className="font-semibold text-lg">Top Rated</div>
              <div className="w-full flex flex-col gap-3">
                {topRatedProducts?.length > 0 ? (
                  topRatedProducts.slice(0, 3).map((item: any) => (
                    <SpecialProductCard
                      key={item.id}
                      product={{
                        id: item.productId,
                        name: item.productName,
                        sellingPriceWithTax: item.sellingPrice,
                        avgProductRating: item.rating,
                        images: item.productImages,
                      }}
                    />
                  ))
                ) : (
                  <div className="flex w-full justify-center text-center font-[600] opacity-40 text-[#05A30D]">
                    No Top Rated Products Available
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${SUmmerSale})`,
              backgroundSize: "cover",
            }}
            className={`w-full h-52 bg-center lg:h-auto lg:w-1/4 flex flex-col gap-1 items-center rounded-md bg-green-100 pt-4 pb-3 lg:pt-8`}
          >
            <div className="font-semibold text-sm text-center">Summer Sale</div>
            {/* <div className="text-[#05A30D] font-bold text-2xl">75% Off</div> */}
            <div
              ref={buttonRef}
              className="bg-white shadow-custom px-4 py-3 flex items-center rounded-full text-xs font-semibold mt-3 text-[#05A30D] cursor-pointer transition-all hover:scale-110"
            >
              Shop Now{" "}
              <div
                className={`transition-all ml-2 ease-in-out  ${
                  hover && "translate-x-2"
                }`}
              >
                <FaArrowRight size={15} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductsList;
